import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { ErrorBoundary } from './components/ErrorBoundary.jsx';
import App from './App.jsx';
import './styles/index.css';

const CLERK_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!CLERK_KEY) {
  console.warn('Missing VITE_CLERK_PUBLISHABLE_KEY — auth will not work. Running in local dev mode.');
}

const AppWithAuth = CLERK_KEY ? (
  <ClerkProvider publishableKey={CLERK_KEY} appearance={{
    variables: { colorPrimary: '#E8553D', colorBackground: '#FAFAFA', colorText: '#1C1C28', colorInputBackground: '#EDEBE8', colorInputText: '#1C1C28' },
  }}>
    <App />
  </ClerkProvider>
) : <App />;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      {AppWithAuth}
    </ErrorBoundary>
  </React.StrictMode>
);

// Register service worker for PWA
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
